import React from "react";
// import moment from "moment";

const DateField = ({ label = "Date", value, onChange }) => {
    return (
        <div style={{ marginBottom: "1.25rem" }}>
            <label style={{ fontSize: 13, fontWeight: 500, color: "#555", display: "block", marginBottom: 6 }}>
                {label} <span style={{ color: "#E24B4A" }}>*</span>
            </label>

            <input
                type="date"
                value={value}
                // max={moment().format("YYYY-MM-DD")}
                onChange={(e) => onChange(e.target.value)}
                style={{
                    width: "100%",
                    padding: "10px 12px",
                    fontSize: 14,
                    border: "0.5px solid #ddd",
                    borderRadius: 8,
                    background: "#fafafa",
                }}
            />
        </div>
    );
};

export default DateField;